import React from "react";
import "./HeaderInvert.css";

function HeaderInvert({ text }) {
  return (
    <section className="headerinvert">
      <h2>{text}</h2>
    </section>
  );
}

export default HeaderInvert;
